import { useContext } from "react";
import { ChatConnections } from "./Connections";
import { ChatContainerHeader } from "./Header";
import { UserListContainer } from "./UserList";
import styles from "../../index.module.scss";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";

export const ChatUserListSection = ({
  connections,
  showMoreBtn,
  userList,
  setChatUser,
  userListLoad,
  onlineUsers,
  handleClick,
  listComplete,
  showLess,
  showMoreStatus,
  notificationData,
  notificationUser,
}) => {
  const { toggleChatSection } = useContext(UserContext);

  return (
    <>
      <ChatContainerHeader />
      <div className={styles.chatBotContainerDiv} id="chatSectionDiv">
        <ChatConnections
          userList={connections}
          showMoreBtn={showMoreBtn}
          handleClick={handleClick}
          listComplete={listComplete}
          showLess={showLess}
          showMoreStatus={showMoreStatus}
          onlineUsers={onlineUsers}
          notificationData={notificationData}
          notificationUser={notificationUser}
        />
        <UserListContainer
          userList={userList}
          toggleChatSection={toggleChatSection}
          setChatUser={setChatUser}
          userListLoad={userListLoad}
          onlineUsers={onlineUsers}
          handleClick={handleClick}
          notificationData={notificationData}
          notificationUser={notificationUser}
        />
      </div>
    </>
  );
};
